module.exports = __webpack_public_path__ + "img/img_mframe02.0bc7fae9.png";